import { Carousel } from '@arco-design/web-react'
import useLocale from '@/utils/useLocale'
import styles from './style/index.module.less'

export default function LoginBanner() {
  const t = useLocale()
  const data = [
    {
      slogan: t['login.banner.slogan1'],
      subSlogan: t['login.banner.subSlogan1'],
      sloganDesc: t['login.banner.sloganDesc1'],
      sloganSubDesc: t['login.banner.sloganSubDesc1'],
      image: 'https://static.echotik.shop/banner/login-banner.webp'
    }
  ]
  return (
    <Carousel className={styles.carousel} animation="fade">
      {data.map((item, index) => (
        <div key={`${index}`}>
          <div className={styles['carousel-column']}>
            <div
              className={styles['carousel-item']}
              // style={{
              //   background: `url("${item.image}") no-repeat`,
              //   backgroundSize: '100%',
              //   backgroundPosition: 'left bottom'
              // }}
            >
              <div className={styles['carousel-title']}>{item.slogan}</div>
              <div className={styles['carousel-sub-title']}>{item.subSlogan}</div>
              <div className={styles['carousel-title-desc']}>{item.sloganDesc}</div>
              <div className={styles['carousel-title-desc']}>{item.sloganSubDesc}</div>
            </div>
            <img alt="banner-image" className={styles['carousel-image']} src={item.image} />
          </div>
        </div>
      ))}
    </Carousel>
  )
}
